export const GET_USERS_SESSION_QUERY_KEY = "getUsersSession";
export const IS_MFA_ENROLLED_QUERY_KEY = "isMfaEnrolled";
